import React from 'react';
import { Col, Row } from 'react-bootstrap';
import ChangeRequestsList from './ChangeRequestsList';
import { useEmployeeDataChangeRequestsQuery } from '../../../__generated__/graphql';
import Loading from './ChangeRequestsList/Loading';
import ServerError from '../../../../../components/ServerError';

export const MyTeamChangeRequests: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { data, loading, error } = useEmployeeDataChangeRequestsQuery();

  if (loading) {
    return <Loading />;
  }

  if (error || data === undefined) {
    return <ServerError />;
  }

  return (
    <>
      <Row>
        <Col>
          <ChangeRequestsList
            mode="manager"
            changeRequests={data.employeeDataChangeRequests}
          />
        </Col>
      </Row>
    </>
  );
};
